
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid2,
} from '@mui/material';

function NoteTypeDialog({ open, onClose, onSelect }) {
  const [noteType, setNoteType] = React.useState('');

  const handleChange = (event) => {
    setNoteType(event.target.value);
  };

  const handleSubmit = () => {
    if (noteType) {
      onSelect(noteType);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Note Type</DialogTitle>
      <DialogContent dividers>
        <Grid2 container justifyContent="center" sx={{ py: 2 }}>
          <Grid2 item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="note-type-label">Note Type</InputLabel>
              <Select
                labelId="note-type-label"
                value={noteType}
                label="Note Type"
                onChange={handleChange}
                sx={{ minWidth: 250 }}
              >
                <MenuItem value="General">General Notes</MenuItem>
                <MenuItem value="Physiotherapy">Physiotherapy Notes</MenuItem>
              </Select>
            </FormControl>
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          disabled={!noteType} 
          variant="contained"
          color="secondary"
        >
         OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NoteTypeDialog;